<template>
  <div class="page password-change">
    <div class="page-inner">
      <PasswordChangeForm ref="refUserForm" :userData="userData" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PasswordChangeForm from "../signUp/comp/userForm/PasswordChangeForm.vue";
const modelService = require("@/utils/dataModel.js");
export default {
  components: {
    PasswordChangeForm,
  },
  data() {
    return {
      userData: modelService.userModel(),
    };
  },
  mounted() {
    this.userData = this.meInfo;
    this.userData.password = "";
    if (this.isDev) {
      // this.userData.currentPassword = "123456789001!";
      // this.userData.password = "123456789!";
      // this.userData.rePassword = "123456789!";
    }
  },
  computed: {
    ...mapGetters(["isDev", "meInfo"]),
  },
  methods: {},
};
</script>
<style lang="scss">
.password-change {
  &.page {
    min-height: auto;


    .page-inner {
      margin: 0 auto 1rem;
      height: calc(100svh - 108px);
      position: relative;

      .v-btn:not(.v-btn--round).v-size--x-large {
        position: absolute;
        bottom: 0;
      }
    }
  }

}
</style>